import React, { useEffect, useState } from "react";
import { Tag } from "antd";
import { LeftOutlined, CheckCircleFilled } from "@ant-design/icons";
import { useSelector } from "react-redux";
import axios from "axios";

const Offer = () => {
  const token = useSelector(
    (state) => state.delivery_user?.delivery_user?.data?.auth_token
  );

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("All");
  const [completedOrders, setCompletedOrders] = useState(0); // Initialize with 0 or fetch from API

  useEffect(() => {
    if (!token) return;

    axios
      .post("https://fleet.howincloud.com/api/v1/eatiko/shift/all", {
        token: token,
      })
      .then((res) => {
        if (res.data.success && res.data) {
          setData(res.data);
        }
      })
      .catch((err) => {
        console.error("Error fetching shift:", err);
      })
      .finally(() => setLoading(false));
  }, [token]);

  console.log("data", data);
  return (
    <div className="p-3 bg-light min-vh-100">
      {/* Header */}
      <div 
  className="d-flex align-items-center  position-relative"
  style={{ 
    width: '100%',
    textAlign: 'center' ,
    marginBottom: '25px'
  }}
>
  {/* <button 
    className=" me-2 p-2 position-absolute" 
    style={{ 
      left: 0,
      top: '50%',
      transform: 'translateY(-50%)' ,
      backgroundColor:"#C2C2C2",
      border: 'none',
      borderRadius: '12px'
    }}
  >
    <LeftOutlined style={{ color: "white", fontWeight: "900" }} />
  </button> */}
  
  <h5
    style={{
      fontWeight: "bold",
      fontSize: "20px",
      margin: '0 auto', // This centers the text
      width: 'fit-content',
      paddingTop: '10px'
    }}
  >
    Extra Earning Offers
  </h5>
</div>

      {/* Tabs with horizontal scrolling */}
      <div
        style={{
          display: "flex",
          gap: "8px",
          marginBottom: "16px",
          overflowX: "auto",
          whiteSpace: "nowrap",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          paddingBottom: "4px",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {/* All tab */}
        <button
          style={{
            borderRadius: "30px",
            padding: "6px 16px",
            fontWeight: "600",

            flexShrink: 0,
            backgroundColor: activeTab === "All" ? "#3853EA" : "#f8f9fa",
            color: activeTab === "All" ? "white" : "black",
            cursor: "pointer",
            outline: "none",
            border: "1px solid #3853EA",
          }}
          onClick={() => setActiveTab("All")}
        >
          All ({data?.data?.length || 0})
        </button>

        {data?.data?.map((shift, i) => (
          <button
            key={shift.id}
            style={{
              borderRadius: "30px",
              padding: "6px 16px",
              fontWeight: "600",
              flexShrink: 0,
              backgroundColor: activeTab === shift.id ? "#3853EA" : "#f8f9fa",
              color: activeTab === shift.id ? "white" : "black",
              cursor: "pointer",
              border: "1px solid #3853EA",
              outline: "none",
            }}
            onClick={() => setActiveTab(shift.id)}
          >
            {shift.name}
          </button>
        ))}
      </div>

      {data?.data?.find((shift) => shift.id === activeTab) && (
        <div style={{ padding: "16px 0" }}>
          {/* Login Incentive Card */}
          <div
            className="bg-white p-3 shadow-sm mb-4"
            style={{ borderRadius: "25px", border: "1px solid #eef0ff" }}
          >
            <div className="d-flex justify-content-between align-items-center " style={{}}>
              <h6 className="fw-bold " style={{ fontSize: "16px",marginBottom:"8px" }}>
                Login Incentive
              </h6>
              <Tag
                style={{ color: "red", fontSize: "10px", fontWeight: "600" }}
              >
                🔴 Live
              </Tag>
            </div>


            <div
              className="p-3  mb-3"
              style={{ backgroundColor: "#eef0ff", borderRadius: "15px" }}
            >
              <div
                className="d-flex justify-content-between align-items-center mb-2"
                style={{ fontSize: "12px", color: "black" }}
              >
                <span>
                  Trips Count:{" "}
                  <strong>
                    {
                      data.data.find((shift) => shift.id === activeTab).login
                        .limit_complete_order_per_day
                    }
                  </strong>
                </span>
                <span
                  className="badge text-white"
                  style={{ backgroundColor: "#3853EA" }}
                >
                  ₹
                  {
                    data.data.find((shift) => shift.id === activeTab).login
                      .amount
                  }
                </span>
              </div>
              <div
                className="position-relative"
                style={{
                  height: "10px",
                  backgroundColor: "#cbd5ff",
                  borderRadius: "5px",
                }}
              >

                <div
                  style={{
                    width: `${Math.min(
                      (completedOrders /
                        parseInt(
                          data.data.find((shift) => shift.id === activeTab)
                            .login.limit_complete_order_per_day
                        )) *
                        100,
                      100
                    )}%`,
                    height: "100%",
                    backgroundColor: "#3b5bff",
                    borderRadius: "5px",
                    position: "relative",
                    transition: "width 0.3s ease",
                  }}
                >

                  <div
                    style={{
                      width: "16px",
                      height: "16px",
                      backgroundColor: "#3b5bff",
                      borderRadius: "50%",
                      position: "absolute",
                      right: "-5",
                      top: "-3px",
                      border: "2px solid white",
                      display:
                        completedOrders >=
                        parseInt(
                          data.data.find((shift) => shift.id === activeTab)
                            .login.limit_complete_order_per_day
                        )
                          ? "none"
                          : "block",
                    }}
                  />

                  {completedOrders >=
                    parseInt(
                      data.data.find((shift) => shift.id === activeTab).login
                        .limit_complete_order_per_day
                    ) && (
                    <div
                      style={{
                        position: "absolute",
                        right: "-5px",
                        top: "-5px",
                        color: "white",
                        backgroundColor: "#3853EA",
                        borderRadius: "50%",
                        width: "20px",
                        height: "20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                      }}
                    >
                      ✓
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Message */}
            <h6 className="fw-bold" style={{ fontSize: "20px" }}>
              Almost there!
            </h6>

            <hr />

            {/* Validity */}
            <div className="mb-2">
              <small className="text-muted fw-semibold">VALIDITY</small>
              <br />
              <span style={{ color: "black" }}>Today</span>
            </div>

            {/* Conditions */}
            <div>
              <small className="text-muted fw-semibold">CONDITIONS</small>
              <br />
              <ul className="ps-3 mb-0" style={{ color: "black" }}>
                <li>
                  Do not reject more than{" "}
                  {
                    data.data.find((shift) => shift.id === activeTab).login
                      .limit_reject_order_per_day
                  }{" "}
                  orders in the day
                </li>
                <li>
                  Login{" "}
                  {
                    data.data.find((shift) => shift.id === activeTab).login
                      .login_hrs
                  }{" hrs "}
                  during{" "}
                  {data.data.find((shift) => shift.id === activeTab).start_time}{" "}
                  to{" "}
                  {data.data.find((shift) => shift.id === activeTab).end_time}
                </li>
               
              </ul>
            </div>
          </div>

          {/* Weekly Bonus Card */}
          <div
            className="bg-white shadow-sm mb-4 border"
            style={{ borderRadius: "20px", overflow: "hidden" }}
          >
            {/* Gradient Header */}
            <div
              className="px-3 py-2 fw-semibold text-dark"
              style={{
                background: "linear-gradient(90deg, #D1D9FF, #f5f9ff)",
                fontSize: "14px",
              }}
            >
              Weekly Bonus
            </div>

            {/* Bonus Message */}
            <div className="p-3">
              <p
                className="mb-3 fw-bold"
                style={{
                  fontSize: "16px",
                  color: "#3853EA",
                  fontWeight: "600",
                }}
              >
                Get ₹
                {
                  data.data.find((shift) => shift.id === activeTab).weekly
                    .amount
                }{" "}
                weekly bonus
              </p>

              {/* Validity */}
              <div className="mb-3">
                <small className="text-muted fw-semibold d-block">
                  WEEKLY VALIDITY
                </small>
                <span className="text-dark">All week</span>
              </div>

              {/* Conditions */}
              <div>
                <small className="text-muted fw-semibold d-block">
                  CONDITIONS
                </small>
                <ul className="ps-3 mb-0" style={{ color: "black" }}>
                  <li>
                    Do not reject more than{" "}
                    {
                      data.data.find((shift) => shift.id === activeTab).weekly
                        .limit_reject_order_per_day
                    }{" "}
                    orders
                  </li>
                  <li>
                    Week login hours:{" "}
                    {
                      data.data.find((shift) => shift.id === activeTab).weekly
                        .week_login_hrs
                    } {" hrs "}
                  </li>
                  <li>
                    Weekends login hours:{" "}
                    {
                      data.data.find((shift) => shift.id === activeTab).weekly
                        .weekends_login_hrs
                    }{" hrs "}
                  </li>
                 
                </ul>
              </div>
            </div>

            {/* Footer link */}
            <div
              className="px-3 py-2 border-top fw-semibold d-flex align-items-center"
              style={{ fontSize: "14px", cursor: "pointer", color: "#3853EA" }}
            >
              What is Weekly Bonus <span className="ms-1">▶</span>
            </div>
          </div>

          {/* Max Bonus Card */}
          <div
            className="bg-white shadow-sm mb-4 border"
            style={{ borderRadius: "20px", overflow: "hidden" }}
          >
            {/* Gradient Header */}
            <div
              className="d-flex justify-content-between align-items-center px-3 py-2"
              style={{
                background: "linear-gradient(90deg, #aef5d6, #e1fff3)",
                fontSize: "14px",
                fontWeight: 600,
              }}
            >
              <span className="text-dark">
                Max. Bonus (
                {
                  data.data.find((shift) => shift.id === activeTab).bonus
                    .limit_complete_order_per_day
                }{" "}
                of{" "}
                {
                  data.data.find((shift) => shift.id === activeTab).bonus
                    .limit_complete_order_per_day
                }
                )
              </span>
              <CheckCircleFilled
                style={{ color: "#00C851", fontSize: "18px" }}
              />
            </div>

            {/* Content */}
            <div className="p-3">
              <div className="d-flex justify-content-between align-items-start mb-3">
                <p
                  className="fw-bold text-dark m-0"
                  style={{ fontSize: "16px", fontWeight: "600" }}
                >
                  Get ₹
                  {
                    data.data.find((shift) => shift.id === activeTab).bonus
                      .amount
                  }{" "}
                  extra per order!
                </p>

                <div
                  className="text-white d-flex"
                  style={{
                    backgroundColor: "#00C851",
                    borderRadius: "10px",
                    padding: "4px 8px",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  ₹
                  {
                    data.data.find((shift) => shift.id === activeTab).bonus
                      .amount
                  }
                  <span
                    style={{
                      fontSize: "10px",
                      lineHeight: "1",
                      marginRight: "10px",
                      marginLeft: "5px",
                    }}
                  >
                    Bonus <br /> Earned
                  </span>
                </div>
              </div>

              {/* Validity */}
              <div className="mb-3">
                <small className="text-muted fw-semibold d-block">
                  BONUS VALIDITY
                </small>
                <span className="text-dark">
                  {data.data.find((shift) => shift.id === activeTab).start_time}{" "}
                  to{" "}
                  {data.data.find((shift) => shift.id === activeTab).end_time}
                </span>
              </div>

              {/* Conditions */}
              <div>
                <small className="text-muted fw-semibold d-block">
                  CONDITIONS
                </small>
                <ul className="ps-3 mb-0" style={{ color: "black" }}>
                  <li>
                    Complete{" "}
                    {
                      data.data.find((shift) => shift.id === activeTab).bonus
                        .limit_complete_order_per_day
                    }{" "}
                    orders
                  </li>
                  <li>
                    Login hours:{" "}
                    {
                      data.data.find((shift) => shift.id === activeTab).bonus
                        .login_hrs
                    }{" hrs "}
                  </li>
                 
                </ul>
              </div>
            </div>

            {/* Footer link */}
            <div
              className="px-3 py-2 border-top fw-semibold d-flex align-items-center"
              style={{ fontSize: "14px", cursor: "pointer", color: "#3853EA" }}
            >
              What is Max. Bonus <span className="ms-1">▶</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Offer;
